import { render } from "./LazySection.vue?vue&type=template&id=02db30fc"
import script from "./LazySection.vue?vue&type=script&lang=js"
export * from "./LazySection.vue?vue&type=script&lang=js"

import "./LazySection.vue?vue&type=style&index=0&id=02db30fc&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__